// Use https://www.minifier.org/ to minify the widget.css file in public folder
const baseStyles =
  "seez-sdk-seezar{position:fixed;z-index:10000;display:flex;gap:1rem;height:fit-content;flex-direction:column-reverse;margin-block:auto}.topLeft seez-sdk-seezar,.topRight seez-sdk-seezar{flex-direction:column}seez-sdk-seezar>button{display:block;height:60px;width:60px;border:none;cursor:pointer}seez-sdk-seezar>.seeztip{padding:.5rem .75rem;margin-block:0;border-radius:6px;list-style:none;font-size:.8rem}seez-sdk-seezar>.seeztip>img{height:32px;vertical-align:middle;margin-inline-end:0.5rem}seez-sdk-seezar>.seeztip>b{vertical-align:middle}seez-sdk-seezar>.seeztip>p{margin-block:.5rem 0}seez-sdk-seezar>.seeztip>button{margin:0;padding:0;background:none;border:none;cursor:pointer;float:right}seez-sdk-seezar>.seeztip>li{margin-block:1rem;cursor:pointer;max-width:20em}seez-sdk-seezar>.seeztip>li::after{content:'\u27A4';float:right;margin-inline-start:1rem}seez-sdk-seezar>.seeztip>li:last-child{margin-block-end:0}seez-sdk-seezar>.seeztip>li:first-child{margin-block-start:0}seez-sdk-seezar.open>.seeztip{display:none}@media screen and (min-width:768px){seez-sdk-seezar>.sampleQuestions{display:none}}.expand{animation:expandAndShrink 2s ease-in-out normal}@keyframes expandAndShrink{0%,100%{transform:scale(1);opacity:1}50%{transform:scale(1.3);opacity:1}}.shakeHorizontal{animation:shake 2s ease-in-out}@keyframes shake{0%,100%{translate:0}10%,30%,50%,70%,90%{translate:-10px 0}20%,40%,60%,80%{translate:10px 0}}.shakeVertical{animation:shakeAt45Degrees 2.5s ease-in-out normal}@keyframes shakeAt45Degrees{0%,100%{transform:rotate(0deg) translate(0,0)}10%,30%,50%,70%,90%{transform:rotate(-45deg) translate(-5px,5px)}20%,40%,60%,80%{transform:rotate(45deg) translate(5px,-5px)}}.bounce{animation:bounce 2s ease-in-out normal}@keyframes bounce{0%,20%,50%,80%,100%{transform:translateY(0)}40%{transform:translateY(-30px)}60%{transform:translateY(-15px)}}.pulse{animation:pulse 2s ease-in-out normal}@keyframes pulse{0%{transform:scale(1)}50%{transform:scale(1.05)}100%{transform:scale(1)}}.swing{animation:swing 2s ease-in-out normal}@keyframes swing{20%{transform:rotate(80deg)}40%{transform:rotate(-40deg)}60%{transform:rotate(80deg)}80%{transform:rotate(-40deg)}100%{transform:rotate(0deg)}}.flip{animation:flip 2s ease-in-out normal}@keyframes flip{0%{transform:rotateY(0)}50%{transform:rotateY(180deg)}100%{transform:rotateY(0)}}"

export default class SeezarButton extends HTMLElement {
  #closeFunction = null
  #config = null
  #button = null
  #isOpen = false
  #welcome = null
  #sampleQuestions = null
  #dialogStyles = null
  #currentSessionId = sessionStorage.getItem('Seez-Session-Id')
  #lastSessionId = localStorage.getItem('Last-Session-Id')
  #isNewSession = this.#lastSessionId != this.#currentSessionId

  constructor() {
    super()
    this.#button = document.createElement('button')
    this.#button.onclick = this.#click.bind(this)

    this.#fetchConfig().then(() => {
      this.#applyStyles()
      this.appendChild(this.#button)
      const ca = this.#config?.customAttributes
      const autostartTime = parseInt(ca?.find(a => a.key === 'chatStartTime')?.value) || 5
      const autoStartChat = ca?.find(a => a.key === 'automatedChatStart')?.value?.toLowerCase() === 'true'
      if (this.#isNewSession && window.innerWidth > 768 && autoStartChat) setTimeout(() => this.#click(true), autostartTime * 1000) // in desktop view only

      if (this.#config?.sampleQuestions?.length > 0 && this.#isNewSession) {
        this.#sampleQuestions = document.createElement('ul')
        this.#sampleQuestions.className = 'seeztip sampleQuestions'
        this.#config.sampleQuestions.forEach(q => {
          if (q) {
            const li = document.createElement('li')
            li.textContent = q
            li.onclick = () => window.seezSdk.openChat(q)
            this.#sampleQuestions.appendChild(li)
          }
        })
        Object.assign(this.#sampleQuestions.style, { background: this.#config.avatarBgColor })

        if (this.#sampleQuestions.children.length) this.appendChild(this.#sampleQuestions)
      }

      if (this.#config?.welcomeMessage && this.#isNewSession) {
        this.#welcome = document.createElement('div')
        this.#welcome.className = 'seeztip'
        this.#welcome.innerHTML = `<img src="https://platform.seez.dev/image/0x0/${this.#config.botAvatarImage}.webp" /><b>${this.#config.botName || 'Seezar'}</b>
        <button id='seez-close-tooltip''>
          <svg viewBox="0 0 16 16" width="14px" height="14px" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Frame">
              <path id="Vector" d="M3.05 3.05C3.24 2.86 3.49 2.76 3.76 2.76 4.02 2.76 4.28 2.86 4.46 3.05L8 6.59 11.54 3.05C11.72 2.87 11.98 2.77 12.24 2.77 12.5 2.77 12.75 2.88 12.94 3.06 13.12 3.25 13.23 3.5 13.23 3.76 13.23 4.02 13.13 4.28 12.95 4.46L9.41 8 12.95 11.54C13.13 11.72 13.23 11.98 13.23 12.24 13.23 12.5 13.12 12.75 12.94 12.94 12.75 13.12 12.5 13.23 12.24 13.23 11.98 13.23 11.72 13.13 11.54 12.95L8 9.41 4.46 12.95C4.28 13.13 4.02 13.23 3.76 13.23 3.5 13.23 3.25 13.12 3.06 12.94 2.88 12.75 2.77 12.5 2.77 12.24 2.77 11.98 2.87 11.72 3.05 11.54L6.59 8 3.05 4.46C2.86 4.28 2.76 4.02 2.76 3.76 2.76 3.49 2.86 3.24 3.05 3.05Z" fill="black"/>
            </g>
          </svg>
        </button>
      <p>${this.#config.welcomeMessage}</p>`
        Object.assign(this.#welcome.style, { background: this.#config.avatarBgColor })

        this.appendChild(this.#welcome)
        this.#welcome.querySelector('#seez-close-tooltip').addEventListener('click', this.#removeTooltips.bind(this))
      }
    })

    this.#setOpenChatFunction()
  }

  #setOpenChatFunction() {
    window.seezSdk.openChat = async (message = '') => {
      const eventType = 'externallyOpenChatModal'
      const eventData = { detail: { message } }

      if (!this.#closeFunction) {
        await this.#click(true)
        setTimeout(() => {
          this.#dispatchChatEvent(eventType, eventData)
        }, 2000) // waiting for the chat compponent to mount
      } else {
        this.#dispatchChatEvent(eventType, eventData)
      }
    }
  }

  #dispatchChatEvent(type, options) {
    const event = new CustomEvent(type, options)
    window.dispatchEvent(event)
  }

  async #click(open) {
    if (typeof open === 'boolean' && open === this.#isOpen) return
    this.#isOpen = typeof open === 'boolean' ? open : !this.#isOpen
    this.#applyStyles()

    if (this.#isOpen) {
      this.classList.add('open')
      const { component, closeFunction } = await window.seezSdk.showComponent('seez-sdk-seezar-chat', { styles: this.#dialogStyles })
      component.addEventListener('close', () => this.#click(false))
      this.#closeFunction = closeFunction
      if (this.#isNewSession) this.#removeTooltips()
    } else {
      await this.#closeFunction()
      this.#closeFunction = null
      this.classList.remove('open')
    }
  }

  #getBotId() {
    const routes = window.seezSdk.targetSite?.botsRoutes
    if (routes == null || routes.length == 0) return null
    for (const r of routes) if (new RegExp(r[0], 'g').test(window.location.href)) return r[1]
    return null
  }

  async #fetchConfig() {
    const botId = this.#getBotId()
    const res = await fetch(`${import.meta.env.VITE_SEEZ_BASE_URL}/config/widget/${botId}`)
    const wc = await res.json()
    this.#config = wc.config
  }

  #applyStyles() {
    const c = this.#config

    const widgetMargins = { marginNone: '0rem ', marginSmall: '0.5rem', marginMedium: '1rem', marginLarge: '2rem', marginExtraLarge: '7rem' }
    const customCss = JSON.parse(c.customCss || '{}')
    const wm = widgetMargins[customCss?.widgetMargin ?? 'marginSmall']
    const wa = customCss?.widgetAnimation || 'none'
    if (wa !== 'none') this.#button.classList.add(wa)

    this.classList.add(c.widgetPosition)
    Object.assign(this.style, {
      insetInline: c.widgetPosition?.endsWith('Left') ? `${wm} auto` : `auto ${wm}`,
      insetBlock: this.#isOpen || c.widgetPosition?.startsWith('bottom') ? `auto ${wm}` : c.widgetPosition?.startsWith('top') ? `${wm} auto` : '50%'
    })

    const iconUrl = this.#isOpen ? 'data:image/svg+xml,<svg viewBox="0 0 12 7" stroke="black" xmlns="http://www.w3.org/2000/svg"><path d="M10 2 6 6M2 2 6 6" stroke-width="1" stroke-linecap="round" /></svg>' : `https://platform.seez.dev/image/0x0/${c.widgetIcon}.webp`

    Object.assign(this.#button.style, {
      marginInline: 'auto 0',
      borderRadius: c.borderRadius === 'rounded' ? '48px' : '6px',
      background: `${c.primaryColor} url('${iconUrl}') no-repeat center center`,
      backgroundSize: '32px'
    })

    this.#dialogStyles = {
      'insetInline': this.style.insetInline,
      'insetBlock': `auto calc(${wm} + 1rem + 64px)`,
      'border': 'none',
      'background': 'none',
      'padding': 0,
      'position': 'fixed',
      'z-index': 10000
    }

    if (!document.head.querySelector('#seez-sdk-seezar-widget-styles')) {
      const bs = document.createElement('style')
      bs.textContent = baseStyles
      bs.id = 'seez-sdk-seezar-widget-styles'
      document.head.appendChild(bs)
    }
  }

  #removeTooltips() {
    this.#welcome.remove()
    this.#sampleQuestions?.remove()
    this.#setLastSessionId()
  }

  #setLastSessionId() {
    this.#lastSessionId = this.#currentSessionId
    localStorage.setItem('Last-Session-Id', this.#lastSessionId)
    this.#isNewSession = false
  }
}
